export default function Resources({context}) {
    return (<>
        <h2>{context.menu_resources}</h2>
        <div className="res-grid">
            <a href="https://process.dmv.ny.gov/TitleStatus" target="_blank" rel="noopener noreferrer">{context.resource1}</a>
            <a href="https://www.northamericanmotoring.com/forums/vindecoder.php" target="_blank" rel="noopener noreferrer">{context.resource2}</a>
        </div>
    </>)
}